import axios from "axios";

export default {
  get: (url, params = {}) => {
    return axios({
      url: `/api/${url}`,
      method: "get",
      params
    });
  },

  post: (url, params = {}, data, headers) => {
    return headers
      ? axios({
          url: `/api/${url}`,
          method: "post",
          params,
          data
        })
      : axios({
          url: `/api/${url}`,
          method: "post",
          params,
          data,
          headers
        });
  },

  put: (url, params = {}, data) => {
    return axios({
      url: `/api/${url}`,
      method: "put",
      params,
      data
    });
  },

  patch: (url, params = {}, data) => {
    return axios({
      url: `/api/${url}`,
      method: "patch",
      params,
      data
    });
  },

  delete: url => {
    return axios({
      url: `/api/${url}`,
      method: "delete"
    });
  },

  download: (url, params, successCallback, errorCallback) => {
    axios({
      url: url,
      method: "get",
      params: params,
      responseType: "blob"
    })
      .then(response => {
        let disposition = response.headers["content-disposition"];
        let filename = decodeURI(
          disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)[1]
        );
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename); //or any other extension
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        if (typeof successCallback === "function") successCallback(response);
      })
      .catch(error => {
        if (typeof errorCallback === "function") errorCallback(response);
      });
  }
};
